import { computed, useAttrs, useSlots } from 'vue'

export function useGpxSelectAttrs(
  remoteEnabled: { value: boolean },
  options?: { usesInternalValueSlot?: { value: boolean } },
) {
  const attrs = useAttrs()
  const slots = useSlots()

  const showRemoteFilter = computed(() => {
    if (!remoteEnabled.value) {
      return false
    }
    if (attrs.filter === false) {
      return false
    }
    return attrs.filter !== undefined && attrs.filter !== null
  })

  const filterPlaceholder = computed(
    () => attrs.filterPlaceholder ?? attrs['filter-placeholder'] ?? '',
  )

  const resetFilterOnHide = computed(
    () =>
      attrs.resetFilterOnHide === '' ||
      attrs.resetFilterOnHide === true ||
      attrs['reset-filter-on-hide'] === '',
  )

  const autoFilterFocus = computed(
    () => attrs.autoFilterFocus !== false && attrs['auto-filter-focus'] !== false,
  )

  const forwardedSlotNames = computed(() => {
    const names = Object.keys(slots).filter((name) => name !== 'option')
    const withoutHeader = showRemoteFilter.value
      ? names.filter((name) => name !== 'header')
      : names
    if (remoteEnabled.value) {
      return withoutHeader.filter((name) => name !== 'empty' && name !== 'value')
    }
    if (options?.usesInternalValueSlot?.value) {
      return withoutHeader.filter((name) => name !== 'value')
    }
    return withoutHeader
  })

  const mergedAttrs = computed(() => {
    const {
      filter,
      filterFields,
      loading,
      virtualScrollerOptions,
      options: optionsAttr,
      emptyMessage,
      'empty-message': emptyMessageKebab,
      optionLabel,
      'option-label': optionLabelKebab,
      optionValue,
      'option-value': optionValueKebab,
      dataKey,
      'data-key': dataKeyKebab,
      valueKey,
      'value-key': valueKeyKebab,
      labelKey,
      'label-key': labelKeyKebab,
      ...rest
    } = attrs
    return rest
  })

  const effectiveFilter = computed((): boolean => {
    if (remoteEnabled.value) {
      return false
    }
    if (attrs.filter === false) {
      return false
    }
    return attrs.filter != null
  })

  const remoteEmptyMessage = computed(
    () =>
      (attrs.emptyMessage as string | undefined) ??
      (attrs['empty-message'] as string | undefined) ??
      'No available options',
  )

  return {
    attrs,
    showRemoteFilter,
    filterPlaceholder,
    resetFilterOnHide,
    autoFilterFocus,
    forwardedSlotNames,
    mergedAttrs,
    effectiveFilter,
    remoteEmptyMessage,
  }
}
